export default __webpack_public_path__ + "static/media/ID card.793abbe7.svg";